import * as React from 'react';
import { SvgWrapper } from '../utils';
import type { IconProps } from '../utils';

const svg = (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="20.5 17 28 28" width="1em" height="1em">
    <g fill="#ff6e00">
      <path d="M28.7 30.24l-7.8 2.66c-.09-.63-.13-1.28-.13-1.94 0-2.02.43-3.94 1.21-5.66 0 0 6.71 4.73 6.75 4.76s.06.06.06.09c0 .05-.04.07-.09.09m5.82-13.08c-2.72.01-5.25.8-7.38 2.17l5.67 6c.04.04.06.06.1.06.03 0 .07-.02.08-.09.07-.38 1.53-8.14 1.53-8.14zm-4.34 9.95s0-.04-.02-.07c-.02-.04-3.11-7.66-3.11-7.66a13.862 13.862 0 00-5.03 5.82s7.95 1.96 8.01 1.98c.02.01.05.01.07.01.04 0 .08-.03.08-.08zm10.26 3.13l7.8 2.66c.09-.63.13-1.28.13-1.94 0-2.02-.43-3.94-1.21-5.66 0 0-6.71 4.73-6.75 4.76s-.06.06-.06.09c0 .05.05.07.09.09zm-4.28-4.94c0 .06.05.09.08.09s.06-.02.1-.06l5.67-6a13.704 13.704 0 00-7.38-2.17c-.01 0 1.45 7.76 1.53 8.14zm2.89 1.89s.05 0 .07-.01c.06-.02 8.01-1.98 8.01-1.98-1.1-2.38-2.85-4.4-5.03-5.82 0 0-3.09 7.62-3.11 7.66 0 .03-.02.05-.02.07 0 .05.03.08.08.08zM34.57 44.76c6.92 0 12.65-5.09 13.65-11.73l-5.14.72c-.08 0-.11.05-.13.11a8.84 8.84 0 01-6.78 5.81 3.651 3.651 0 10-5.25-3.28c0 1.44.84 2.69 2.05 3.28a8.84 8.84 0 01-6.78-5.81c-.02-.06-.05-.1-.13-.11l-5.15-.72c1.02 6.64 6.75 11.73 13.66 11.73" />
    </g>
  </svg>
);

const Bdrc = ({
  style = {
    primaryColor: 'currentColor',
    bgColor: 'transparent',
  },
  size = '1em',
  active = false,
  ...rest
}: IconProps) => (
  <SvgWrapper style={style} size={size} active={active} {...rest}>
    {svg}
  </SvgWrapper>
);

export default Bdrc;
